<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-card>
          <v-card-text>
            <p class="subheading"><strong>CREATIVITY:</strong> the value of turning ideas into innovative and socially-responsive solutions</p>
            <p class="subheading"><strong>SELF-RELIANCE:</strong> the ability to have confidence in and exercise one’s own judgment.</p>
            <p class="subheading"><strong>INTEGRITY:</strong> the value of having commitment, honesty, competence, transparency and responsibility.</p>
            <p class="subheading"><strong>TEAMWORK:</strong> the ability to support others and place the team over individual importance.</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/About/CoreValues.vue